import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { IBInputProps } from './Input.types';
import { baseColors } from '../../theme/colors';
import './Input.scss';

export const InputNone = styled.input`
  border: unset;
  padding: unset;
  margin: unset;
  background: unset;
`;

export const InputBase = styled.input`
  width: 100%;
  margin: unset;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 36px;
  padding-left: 8px;
`;

export const InputLabel = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 20px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const StyledInput = styled.input<IBInputProps>`
  width: 100%;
  margin: unset;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 36px;
  padding-left: 8px;
  outline: none;
  border: 0.75px solid ${({ theme }) => theme.colors.primary};
  border-radius: 0;
  &:hover,
  &:focus,
  &:active,
  &:focus-visible {
    border: 0.75px solid black;
  }
  &:disabled {
    background-color: ${({ theme }) => theme.colors.d4};
    color: ${({ theme }) => theme.colors.d3gray};
  }
  ${({ styleType, theme }) =>
    _.isEqual(styleType, 'standard') &&
    `
    background-color: ${theme.colors.surface};
    border: 0.75px solid ${theme.colors.primary};
    border-radius: 0;`};
  border: ${({ errorMessage, error }) =>
    (errorMessage || error) && `0.75px solid ${baseColors.alert} !important`};
`;

const Input: React.FC<IBInputProps> = (props: IBInputProps) => {
  const {
    name,
    disabled,
    placeholder,
    value,
    type,
    onChange,
    id,
    onBlur,
    className,
    testId,
    error
  } = props;
  return (
    <div className={className ?? ''}>
      <StyledInput
        name={name}
        error={error}
        {...props}
        onBlur={() => onBlur && onBlur()}
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        value={value ?? ''}
        type={type ?? 'text'}
        className="input"
        onChange={e => {
          if (onChange) {
            onChange(e.target.value);
          }
        }}
        data-testid={testId || 'input'}
      />
    </div>
  );
};

export default Input;
